import React, { forwardRef, useRef, useImperativeHandle } from 'react';
import PropTypes from 'prop-types';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import { getClassName } from '../../utils/ui/classes';
import InfoIcon from './icons/InfoIcon';

const getToolTip = (id, children) => {
  return (
    <Tooltip id={id} style={{ zIndex: 100011 }}>
      {children}
    </Tooltip>
  );
};

const CargomaticTooltip = forwardRef(
  ({ id, children, position, className, body, bodyParams, dataTestId }, ref) => {
    const overlayRef = useRef(null);

    useImperativeHandle(ref, () => ({
      forceClose() {
        overlayRef.current.hide();
      },
    }));

    return (
      (<OverlayTrigger
        ref={overlayRef}
        placement={position}
        overlay={getToolTip(id, children)}
      >
        <div data-testid={dataTestId} className={getClassName(className)}>{body(bodyParams)}</div>
      </OverlayTrigger>)
    );
  },
);

const positions = {
  top: 'top',
  right: 'right',
  bottom: 'bottom',
  left: 'left',
};

function renderIcon(params) {
  const { size } = params;
  return <InfoIcon size={size} />;
}

CargomaticTooltip.propTypes = {
  children: PropTypes.any.isRequired,
  id: PropTypes.string.isRequired,
  position: PropTypes.oneOf(Object.keys(positions)),
  className: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.array,
    PropTypes.object,
  ]),
  body: PropTypes.func,
  bodyParams: PropTypes.object,
};

CargomaticTooltip.defaultProps = {
  position: positions.right,
  className: '',
  body: renderIcon,
  bodyParams: { size: 'small' },
};

export default CargomaticTooltip;
